export interface KlipyFileFormat {
  url: string;
  width?: number;
  height?: number;
  size?: number;
}

export interface KlipyGifFileSizes {
  gif?: KlipyFileFormat;
  webp?: KlipyFileFormat;
  jpg?: KlipyFileFormat;
  mp4?: KlipyFileFormat;
  webm?: KlipyFileFormat;
}

export interface KlipyGifFile {
  hd?: KlipyGifFileSizes;
  md?: KlipyGifFileSizes;
  sm?: KlipyGifFileSizes;
  xs?: KlipyGifFileSizes;
}

export interface KlipyGif {
  id: number | string;
  slug: string;
  title?: string;
  file?: KlipyGifFile;
  type?: string;
}

export interface KlipyGifsResponse {
  results: KlipyGif[];
  currentPage: number;
  hasNext: boolean;
}

export function getKlipyGifPreviewUrl(gif: KlipyGif): string | undefined {
  return (
    gif.file?.sm?.gif?.url
    ?? gif.file?.xs?.gif?.url
    ?? gif.file?.md?.webp?.url
    ?? gif.file?.md?.gif?.url
    ?? gif.file?.hd?.gif?.url
  );
}

/**
 * The GIF saved on a joydrop or comment. Medium, not HD: it looks the same in
 * the feed's media frame at a fraction of the file size, so feeds load faster.
 */
export function getKlipyGifFullUrl(gif: KlipyGif): string | undefined {
  return (
    gif.file?.md?.gif?.url
    ?? gif.file?.hd?.gif?.url
    ?? gif.file?.sm?.gif?.url
    ?? gif.file?.xs?.gif?.url
  );
}

export function getKlipyGifKey(gif: KlipyGif): string {
  return gif.slug || String(gif.id);
}
